
import React, {FC} from 'react';
import {zip} from 'lodash';
import {BarColors} from 'templates/reports/colors';

import * as styles from './styles.module.scss';

type SquareProps = {
	breaks: number[]
	value: number
	reverse?: boolean
}

const Square: FC<SquareProps> = ({breaks, value, reverse}) => {
	const colors = [BarColors.green, BarColors.yellow, BarColors.red];
	if (reverse) {
		colors.reverse();
	}

	let color = colors[0];
	for (const [b, c] of zip(breaks.slice(1), colors)) {
		if (!b || !c) {
			break;
		}

		color = c;
		if (value < b) {
			break;
		}
	}

	return (
		<div
			className={styles.square}
			style={{backgroundColor: color}}
		/>
	);
};

export default Square;
